
const {Base64} = require('js-base64');

//const url = process.env.REACT_APP_API_URL_LOCAL_DEV
const url = process.env.REACT_APP_API_URL_DEV


const getUser = async ({ email }) => {
    
    const response = await fetch(
        `${url}/user?email=${email}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
};

const postShopkeeper = async (requestBody) => {
    try{
        const jsonString = JSON.stringify(requestBody);
        const encodedString = btoa(jsonString);
        const response = await fetch(`${url}/user/shopkeepers`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data:encodedString})
            }
        );
        
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
};

const postSignIn = async (requestBody) => {
    try{
        const jsonString = JSON.stringify(requestBody);
        const encodedString = btoa(jsonString);
        const response = await fetch(`${url}/user/sign-in`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data:encodedString})
            }
        );

        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const postVerificationCode = async (requestBody) => {
    try{
        const jsonString = JSON.stringify(requestBody);
        const encodedString = btoa(jsonString);
        const response = await fetch(
            `${url}/user/verification-code`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data:encodedString})
            }
        );
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
};

const patchVerificationCode = async (requestBody) => {
    try{
        const jsonString = JSON.stringify(requestBody);
        const encodedString = btoa(jsonString);
        const response = await fetch(
            `${url}/user/verification-code`,
            {
                method: "PATCH",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data: encodedString})
            }
        );
        const json = await response.json()
        
        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const getProfile = async (userId) => {

    const response = await fetch(
        `${url}/user/profile?user_id=${userId}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const postProfile = async (requestBody) => {
    try{
        const jsonString = JSON.stringify(requestBody);
        const encodedString = Base64.encode(jsonString);
        const response = await fetch(
            `${url}/user/profile`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data: encodedString})
            }
        )

        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

/** GET FROM LOYALTY */
const getCampaigns = async(queryParams) =>{
    try{
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/loyalty/campaigns?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const getQuizzes= async(queryParams) =>{
    try{
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/loyalty/activities/quizzes?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const postQuiz = async(requestBody)=>{
    try { 
        const jsonString = JSON.stringify(requestBody);
        const encodedString = Base64.encode(jsonString);
        
        const response = await fetch(`${url}/user/quizzes?`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data: encodedString})
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const getRoulettes= async(queryParams) =>{
    try { 
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/loyalty/activities/roulettes?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const postRoulette= async(requestBody) =>{
    try { 
        const jsonString = JSON.stringify(requestBody);
        const encodedString = Base64.encode(jsonString);
        
        const response = await fetch(`${url}/user/roulettes?`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data: encodedString})
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}


const getPolls = async (queryParams) => {
    try {
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/loyalty/activities/polls?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const postPoll = async (requestBody) => {
    try {

        const jsonString = JSON.stringify(requestBody);
        const encodedString = Base64.encode(jsonString);

        const response = await fetch(`${url}/user/polls`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
                body: JSON.stringify({data: encodedString})
            }
        )
        
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: error.message}
    }
}
    
/** GET FROM USER */
const getMyPolls = async (queryParams) => {
    try {
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/user/polls?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}

const getMyQuizzes= async(queryParams) =>{
    try{
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/user/quizzes?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}
const getMyRoulettes= async(queryParams) =>{
    try { 
        const params = new URLSearchParams(queryParams).toString()
        
        const response = await fetch(`${url}/user/roulettes?`+params, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Basic YV9sa0BybGthLmNvbTpsa18zMl8/wqHCv18xMl80NV8kLyQ='
                },
            }
        )
        const json = await response.json()

        return {data: json.data, status: response.status, message: json.message}

    }catch(error){
        return {data: null, status: 400, message: "Ha habido un error"}
    }
}



const getAddresses = async (userId) => {

    const response = await fetch(
        `${url}/user/address?user_id=${userId}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const postAddress = async (data) => {

    const response = await fetch(
        `${url}/user/address`,
        {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },body:{data:data}
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const deleteAddress = async (userId,addressId) => {

    const response = await fetch(
        `${url}/user/address?user_id=${userId}&&address_id=${addressId}`,
        {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const getStats = async (userId) => {
    const response = await fetch(
        `${url}/user/stats?user_id=${userId}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const getProducts = async (categoriaId) => {
    const response = await fetch(
        `${url}/catalog-system/products?categoria_id=${categoriaId}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const getChallenges = async (status) => {
    

    let final_url = `${url}/activities/challenges`

    if(status)
        final_url = `${final_url}?status=${status}`

    const response = await fetch(final_url,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const getRewards = async (eventId) => {

    let final_url = `${url}/loyalty/rewards`

    if(eventId)
        final_url = `${final_url}?event_id=${eventId}`

    const response = await fetch(final_url,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )

    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}

const getPromotions = async () => {
    const response = await fetch(
        `${url}/loyalty/promotions`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }
    )
    
    if(response.status == 200){
        const data = await response.json()
        return {body: data, status: 200, message: "success"}
    }else{
        return {body: null, status: 400, message: "Ha habido un error"}
    }
}


module.exports = {
    getUser,
    postShopkeeper,
    postSignIn,
    postVerificationCode,
    patchVerificationCode,
    getProfile,
    postProfile,
    getAddresses,
    postAddress,
    deleteAddress,
    getStats,
    getProducts,
    getChallenges,
    getPolls,
    getRewards,
    getPromotions,
    postPoll,
    getCampaigns,
    getQuizzes,
    postQuiz,
    getRoulettes,
    postRoulette,
    getMyQuizzes,
    getMyRoulettes,
    getMyPolls,
  };